import { useSettingsContext } from "../../hook/useSettingsContext";
import Skeleton from "./page/Skeleton";

export default function SettingsForm({ children, title, subtitle }) {
    const { loading } = useSettingsContext();
    return (
        <div>
            <div className="bg-white rounded-lg border border-gray-200">
                <div className="border-b border-gray-200 space-y-1 p-8 max-wp:p-5">
                    <h1 className="text-xl font-bold text-gray-900">{title}</h1>
                    <p className="text-sm text-gray-500">{subtitle}</p>
                </div>
                <div className="space-y-8 p-8 max-wp:p-5">
                    {loading.settings || loading.formsDataFetch ? (
                        <Skeleton />
                    ) : (
                        children
                    )}
                </div>
            </div>
        </div>
    );
}
